/* eslint-disable no-empty */
/* eslint-disable no-sequences */
// 加法
export function add(a = 0, b = 0) {
  var c, d, e;
  try {
    c = a.toString().split('.')[1].length;
  } catch (f) {
    c = 0;
  }
  try {
    d = b.toString().split('.')[1].length;
  } catch (f) {
    d = 0;
  }
  return (e = Math.pow(10, Math.max(c, d))), (mul(a, e) + mul(b, e)) / e;
}
// 减
export function sub(a = 0, b = 0) {
  var c, d, e;
  try {
    c = a.toString().split('.')[1].length;
  } catch (f) {
    c = 0;
  }
  try {
    d = b.toString().split('.')[1].length;
  } catch (f) {
    d = 0;
  }
  return (e = Math.pow(10, Math.max(c, d))), (mul(a, e) - mul(b, e)) / e;
}
// 乘
export function mul(a = 0, b = 0) {
  var c = 0;
  var d = a.toString();
  var e = b.toString();
  try {
    c += d.split('.')[1].length;
  } catch (f) { }
  try {
    c += e.split('.')[1].length;
  } catch (f) { }
  return (
    (Number(d.replace('.', '')) * Number(e.replace('.', ''))) / Math.pow(10, c)
  );
}
// 除法
export function div(a = 0, b = 0) {
  var c;
  var d;
  var e = 0;
  var f = 0;
  try {
    e = a.toString().split('.')[1].length;
  } catch (g) { }
  try {
    f = b.toString().split('.')[1].length;
  } catch (g) { }
  return (
    (c = Number(a.toString().replace('.', ''))),
    (d = Number(b.toString().replace('.', ''))),
    mul(c / d, Math.pow(10, f - e))
  );
}